module.exports = __webpack_public_path__ + "static/media/01_A.3cfde91b.jpg";